import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconTwitchStyle0 = gravityIconIndividualCss;

const GravityIconTwitch = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '11c67b4319c68dd1d5eeb1d0b65272970ba60198', color: this.color, size: this.size }, h("svg", { key: 'f123e3b278ca2e5073900966f84967a1e7436ac3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '362ea6787b0d16d169f86ae4efb2ff07a51e76ed', d: "M13.714 6.143h1.143V9.57h-1.143V6.143Zm-2 0h-1.143V9.57h1.143V6.143Z", fill: "currentColor" }), h("path", { key: '5d44520cce3bd89e95e6fe01a24d839152d11d1e', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4 5.857 6.857 3h10.857v8l-5.143 5.143h-2.285L7.429 19v-2.857H4V5.857Zm10.286 6.857 2.285-2.285V4.143H7.43v8.571H10v2l2-2h2.286Z", fill: "currentColor" }))));
    }
};
GravityIconTwitch.style = GravityIconTwitchStyle0;

export { GravityIconTwitch as gravity_icon_twitch };

//# sourceMappingURL=gravity-icon-twitch.entry.js.map